import { makeMutable } from 'react-native-reanimated';
import { INITIAL_PLAYER_INDEX } from './initialPlayerIndex';
export const animatedPlayerIndex = makeMutable(INITIAL_PLAYER_INDEX);
//# sourceMappingURL=animatedPlayerIndex.js.map